import React from 'react';
import { MapPin, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const coreAreas = [
  'Los Angeles',
  'Culver City',
  'Inglewood',
  'Pasadena',
  'West LA',
  'San Gabriel Valley',
  'Valley Communities'
];

const ServiceAreas = () => {
  return (
    <section
      id="service-areas"
      className="section-padding relative grid-pattern grid-pattern-light"
      style={{ backgroundColor: '#F4F1E9' }}
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-12">
          <span className="inline-block font-semibold text-xs tracking-[0.2em] uppercase mb-4 px-4 py-1.5 rounded-full" style={{ color: '#D6A94F', backgroundColor: 'rgba(214, 169, 79, 0.08)', border: '1px solid rgba(214, 169, 79, 0.15)' }}>
            Service Areas
          </span>
          <h2 className="font-display font-bold text-3xl sm:text-4xl mb-4" style={{ color: '#1F3B60' }}>
            Service Areas Across Greater Los Angeles
          </h2>
          <div className="divider-gold mx-auto mb-6" />
          <p className="max-w-2xl mx-auto text-lg" style={{ color: '#3A5A85' }}>
            Pacific Crest Properties provides real estate solutions and renovation services throughout Los Angeles and the surrounding communities.
          </p>
        </div>

        {/* Core Areas Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mb-10">
          {coreAreas.map((area, index) => (
            <div
              key={index}
              className="flex items-center space-x-3 px-4 py-3 rounded-xl bg-white shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <MapPin className="w-5 h-5 flex-shrink-0" style={{ color: '#D6A94F' }} />
              <span className="font-medium" style={{ color: '#1F3B60' }}>{area}</span>
            </div>
          ))}
        </div>

        {/* View All Link */}
        <div className="text-center">
          <Link
            to="/locations"
            className="inline-flex items-center space-x-2 font-semibold transition-all duration-300 hover:space-x-3"
            style={{ color: '#D6A94F' }}
          >
            <span>View All Locations</span>
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreas;
